import CollectionPayload from '@libraries/api/login';
import FetchData from '@utils/fetch-data';
import { notification } from 'antd';
import { getAdditionalHeader, IFetchData } from 'asumsi-components';
import { Dispatch, SetStateAction, useState } from 'react';
import { IParamLogin } from '@interfaces/iparam-login';

export default function useAction() {
    const [isLoader, setIsLoader]: [boolean, Dispatch<SetStateAction<boolean>>] = useState(false);

    const postData = async (params: IParamLogin) => {
        const additionalHeader = getAdditionalHeader();
        const payload: IFetchData = CollectionPayload.post(params);

        setIsLoader(true);
        let res: any = null;
        try {

            const response: any = await FetchData({ ...payload, additionalHeader });
            if (response.data.statusCode == 200 || response.data.statusCode == 201) {
                setIsLoader(false);
                notification.success({
                    message: 'Success',
                    duration: 5,
                    description: 'Berhasil masuk!',
                });
                res = response.data.data;
            } else {
                setIsLoader(false);
                notification.error({
                    message: 'Failed',
                    duration: 5,
                    description: response.data.message || 'Gagal masuk!',
                });
            }

        } catch (error) {
            const { response } = error;
            setIsLoader(false);
            notification.error({
                description: response ? response.data.message : "Gagal masuk!",
                duration: 5,
                message: 'Failed',
            });
        }
        return res;
    };

    return {
        isLoader,
        setIsLoader,
        postData
    };
}



// WEBPACK FOOTER //
// ./src/pages/login/hooks/useAction.tsx